<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <g transform="translate(1 1)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25">
      <circle cx="6" cy="6" r="6"/>
      <path d="m14 14-3.5-3.5"/>
    </g>
  </svg>
</template>
